const bg = {
  // Navbar
  nav_about: 'За нас',
  nav_packages: 'Пакети',
  nav_calculator: 'Калкулатор',
  nav_contacts: 'Контакти',
  nav_start: 'Започни инвестиция',

  // Hero
  hero_badge: 'Сезонен тренд · Пролет 2025',
  hero_title_1: 'Пролетен ръст на',
  hero_title_wheat: 'пшеницата',
  hero_title_2: '— удвой, утрой или',
  hero_title_3: 'учетвори',
  hero_title_4: 'парите си',
  hero_x2_label: '×2 печалба',
  hero_x2_from: 'от €21,100',
  hero_x3_label: '×3 печалба',
  hero_x3_from: 'от €26,000',
  hero_x4_label: '×4 печалба',
  hero_x4_from: 'от €31,000',
  hero_desc: 'Исторически цените на пшеницата се покачват през пролетта поради нарастващото глобално търсене, натиска от сеитбената кампания и изчерпването на зимните запаси. Инвеститорите използват този сезонен цикъл всяка година, за да умножат капитала си.',
  hero_cta_calc: 'Изчисли печалбата',
  hero_cta_packages: 'Виж пакетите',
  hero_stat1_val: '+42%',
  hero_stat1_label: 'Средно пролетно покачване',
  hero_stat2_val: '5+ години',
  hero_stat2_label: 'Стабилен тренд',
  hero_stat3_val: 'ТОП-1',
  hero_stat3_label: 'Световен аграрен актив',
  hero_chart_title: 'Динамика на цената на пшеницата · Пролет',
  hero_chart_sub: 'Индексиран ръст (Февр. = 100%)',
  hero_chart_avg: '+42% средно',
  hero_chart_max: '+56%',
  hero_chart_max_label: 'Максимален сезонен ръст',
  hero_chart_100: '100%',
  hero_chart_100_label: 'Години с положителен ръст',
  hero_scroll: 'превъртете надолу',

  // Why grows
  why_badge: 'Сезонна аналитика',
  why_title_1: 'Защо пшеницата',
  why_title_2: 'расте през пролетта?',
  why_subtitle: 'Пет ключови фактора, формиращи стабилен ценови тренд всяка година',
  why_f1_title: 'Търсене за фураж',
  why_f1_desc: 'През пролетта търсенето на пшеничен фураж рязко нараства от животновъдни предприятия, подготвящи се за активния сезон.',
  why_f1_stat: '+21%',
  why_f1_label: 'ръст на търсенето',
  why_f2_title: 'Сеитбена кампания',
  why_f2_desc: 'Началото на активния пролетен сеитбен период създава пазарен ажиотаж и натиск върху наличните запаси от пшеница.',
  why_f2_stat: '+28%',
  why_f2_label: 'ръст на активността',
  why_f3_title: 'Хранителни производители',
  why_f3_desc: 'Пекарни и хранителни производители увеличават покупките на пшеница преди летния производствен сезон.',
  why_f3_stat: '+19%',
  why_f3_label: 'ръст на покупките',
  why_f4_title: 'Изчерпване на запасите',
  why_f4_desc: 'До пролетта миналогодишните запаси от пшеница са критично ниски, което създава недостиг и тласка цените нагоре.',
  why_f4_stat: '-35%',
  why_f4_label: 'оставащи запаси',
  why_f5_title: 'Пазарни очаквания',
  why_f5_desc: 'Пазарът залага на несигурността около предстоящата реколта — това увеличава волатилността и потенциала за ръст.',
  why_f5_stat: '+33%',
  why_f5_label: 'ръст на волатилността',
  why_stat1_val: '+42%',
  why_stat1_label: 'Средно покачване за 5 години',
  why_text: 'Според статистиката от минали години, пролетният сезон е един от най-активните периоди на ценови ръст за',
  why_wheat: 'Пшеницата',
  why_disclaimer: 'Исторически данни CME Group, USDA · не е финансов съвет',
  why_stat2_val: '100%',
  why_stat2_label: 'Години с ръст (5/5)',

  // Packages
  pkg_badge: 'Инвестиционни договори',
  pkg_title_1: 'Изберете вашия',
  pkg_title_2: 'инвестиционен',
  pkg_title_3: 'договор',
  pkg_subtitle: 'Три нива на участие — удвой, утрой или учетвори капитала си',
  pkg_investment: 'Инвестиция',
  pkg_term: 'Срок',
  pkg_term_val: '2 дни',
  pkg_yield: 'Доходност',
  pkg_profit_label: 'Нетна печалба за 2 дни',
  pkg_invested: 'Инвестирано:',
  pkg_total: 'Общо обратно:',
  pkg_btn: 'Започни инвестиция',
  pkg_disclaimer: '* Всички данни за доходност се основават на историческа пазарна динамика. Инвестициите носят рискове.',
  pkg_popular: 'Популярен',
  pkg_maximum: 'Максимален',
  pkg_p1_name: 'Стартов договор',
  pkg_p1_sub: 'Инвестиции в пшеница · 2 дни',
  pkg_p1_f1: 'Праг на влизане — €21,100',
  pkg_p1_f2: 'Печалба ×2 за 2 дни',
  pkg_p1_f3: 'Месечен отчет',
  pkg_p1_f4: 'Поддръжка 5/7',
  pkg_p1_f5: 'Личен акаунт',
  pkg_p2_name: 'Балансов договор',
  pkg_p2_sub: 'Инвестиции в пшеница · 2 дни',
  pkg_p2_f1: 'Праг на влизане — €26,000',
  pkg_p2_f2: 'Печалба ×3 за 2 дни',
  pkg_p2_f3: 'Седмичен отчет',
  pkg_p2_f4: 'Приоритетна поддръжка',
  pkg_p2_f5: 'Личен акаунт',
  pkg_p2_f6: 'Пазарна аналитика',
  pkg_p3_name: 'Премиум договор',
  pkg_p3_sub: 'Инвестиции в пшеница · 2 дни',
  pkg_p3_f1: 'Праг на влизане — €31,000',
  pkg_p3_f2: 'Печалба ×4 за 2 дни',
  pkg_p3_f3: 'Ежедневен отчет',
  pkg_p3_f4: 'VIP поддръжка 7/7',
  pkg_p3_f5: 'Личен акаунт',
  pkg_p3_f6: 'Пазарна аналитика',
  pkg_p3_f7: 'Личен мениджър',

  // Calculator
  calc_badge: 'Калкулатор на доходност',
  calc_title_1: 'Изчисли',
  calc_title_2: 'своята печалба',
  calc_subtitle: 'Въведи параметрите и разбери очаквания доход',
  calc_amount_label: 'Сума на инвестицията',
  calc_package_label: 'Инвестиционен пакет',
  calc_duration_label: 'Продължителност на инвестицията',
  calc_duration_val: '2 дни',
  calc_duration_note: 'Фиксиран срок за всички договори',
  calc_result_title: 'Резултат от изчислението',
  calc_multiplier: 'множител',
  calc_net_profit: 'Нетна печалба',
  calc_yield: 'доходност / 2 дни',
  calc_total: 'Общо обратно',
  calc_invested_label: 'Инвестиция',
  calc_package_row: 'Пакет',
  calc_period: 'Период',
  calc_period_val: '2 дни',
  calc_bar_invested: 'Инвестирано',
  calc_bar_profit: 'Печалба',
  calc_choose_btn: 'Избери договор',

  // Activity
  act_badge: 'Инвеститорска общност',
  act_title_1: 'Хиляди инвеститори вече',
  act_title_2: 'печелят с нас',
  act_desc: 'Всеки ден нашите клиенти умножават капитала си чрез сезонния пролетен тренд на пшеницата. Присъединете се към хилядите инвеститори, използващи този цикъл всяка година.',
  act_join: 'Присъедини се',
  act_view: 'Виж пакетите',
  act_stat1_val: '12 400+',
  act_stat1_label: 'Активни инвеститори',
  act_stat2_val: '€28M+',
  act_stat2_label: 'Активи под управление',
  act_stat3_val: '97%',
  act_stat3_label: 'Доволни клиенти',
  act_live_title: 'Активност на платформата',
  act_live_note: 'демонстрация в реално време на активността на потребителите',
  act_invested: 'инвестира',
  act_earned: 'спечели печалба',
  act_now: 'сега',

  // Trust
  trust_badge: 'Защо ни се доверяват',
  trust_title_1: 'Надеждност, доказана от',
  trust_title_2: 'времето',
  trust_subtitle: 'Пшеницата е най-ликвидният и предвидим аграрен актив в света',
  trust_c1_title: 'Най-старият търговски инструмент',
  trust_c1_desc: 'Пшеницата е един от най-старите търгувани стоки в историята на човечеството — доказан сезонен инвестиционен инструмент от векове.',
  trust_c2_title: 'ТОП-1 световен аграрен актив',
  trust_c2_desc: 'Пшеницата е №1 глобален аграрен актив по обем на търговия и ликвидност на борсите CME и CBOT по целия свят.',
  trust_c3_title: 'Повишена пролетна волатилност',
  trust_c3_desc: 'Пролетният сезон исторически показва най-висока волатилност и потенциал за ръст, създавайки уникални възможности за печалба.',
  trust_s1_val: '200+',
  trust_s1_label: 'години пазарна история',
  trust_s2_val: '€120B+',
  trust_s2_label: 'годишен обем на търговия',
  trust_s3_val: '#1',
  trust_s3_label: 'глобален аграрен актив',
  trust_s4_val: '99%',
  trust_s4_label: 'ликвидност на позицията',
  trust_cta_text: 'Готов да се възползваш от пролетния тренд на пшеницата? Изчисли потенциалната си печалба сега.',
  trust_cta_btn: 'Изчисли печалбата сега',

  // Footer
  footer_tagline: '— Сезонни инвестиции в пшеница',
  footer_copy: '© 2025 WheatVest. Не е финансов съвет.',

  // Toast
  toast_invested: 'инвестира',
  toast_earned: 'спечели печалба',
};

export default bg;
